$( document ).ready(function() {
  $('#truncated').on('click', function(){
        $('#truncated').fadeOut(300, function(){ 
          $('#fullDescription').fadeIn(500);
        })
      }); 
  $(document).on('click', '.js-open-promo-popup', function (e) {
    e.preventDefault();

    const popup = document.querySelector("#promo-popup");
    popup.classList.add("active");

    // Khóa scroll
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
  }); 
  $(".popup-shiping, .zip-learn-more").on('click', function() {
    $('body').addClass('model-active');
    $(".custom-model-main").addClass('model-open');
  }); 
  $(".popup-features").on('click', function() {
    $('body').addClass('model-active');
    $(".custom-model-features").addClass('model-open');
  }); 
  $(".close-popup-features").on('click', function() {
    $('body').removeClass('model-active');
    $(".custom-model-features").removeClass('model-open');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $('body').removeClass('model-active');
    $(".custom-model-main").removeClass('model-open');
  });
  
  $('.tab-title a ').click(function(){
      $('.tab-title a ').removeClass('active');
      $(this).addClass('active');
    var tabContent = $(this).attr('data-tab');
    $('.tab-content').removeClass('active');
      $('.'+tabContent).addClass('active');
  });
$('.toddler_box').click(function(){
    $(this).toggleClass("active");
  });
  var tabLinks = document.querySelectorAll(".tablinks");
  var tabContent =document.querySelectorAll(".tabcontent");

  tabLinks.forEach(function(el) {
    el.addEventListener("click", openTabs);
  });


  function openTabs(el) {
    var btn = el.currentTarget; // lắng nghe sự kiện và hiển thị các element
    var electronic = btn.dataset.electronic; // lấy giá trị trong data-electronic

    tabContent.forEach(function(el) {
      el.classList.remove("active");
    });

    tabLinks.forEach(function(el) {
      el.classList.remove("active");
    });

    document.querySelector("#" + electronic).classList.add("active");

    btn.classList.add("active");
  }
  var params = new window.URLSearchParams(window.location.search);
  var paramTab = params.get('goto');
  if(paramTab == 'shipping'){
    $("#link2").trigger('click');
  }
  if(paramTab == 'returns'){
    $("#link3").trigger('click');
  }
  if(paramTab == 'warranty'){
    $("#link4").trigger('click');
  }


$('.checkout-button.top-button button').click(function(){
    $(".cart-form>button").trigger("click");
  });

$('.zippay svg').click(function(){
    $(".zip-logo").trigger("click");
  });
$('.sustainability').click(function(){
  if($(".sustainability-tab").attr("aria-expanded") == "false"){
    $(".sustainability-tab .accordion__toggle").trigger("click");
  }
    $('html, body').animate({
        scrollTop: $(".sustainability-tab").offset().top - 200
    }, 800);
  });
$('.fitment').click(function(){
  if($(".fitment_accordion").attr("aria-expanded") == "false"){
    $(".fitment_accordion .accordion__toggle").trigger("click");
  }
    $('html, body').animate({
        scrollTop: $(".fitment_accordion").offset().top - 200
    }, 800);
  });

});

$(window).on('load', function() {
  $(document).on('click', '.js-coupon-code', async function (event) {

    const code = $(this).attr('data-coupon');

    // =========================
    // COPY TO CLIPBOARD
    // =========================
    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      // Fallback
      const textarea = document.createElement('textarea');

      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand('copy');

      textarea.remove();
    }

    // =========================
    // REMOVE TOAST CŨ
    // =========================
    const oldToast = document.querySelector('.promo-copy-toast');

    if (oldToast) {
      oldToast.remove();
    }

    // =========================
    // CREATE TOAST
    // =========================
    const toast = document.createElement('div');

    toast.className = 'promo-copy-toast';
    toast.textContent = code +' Copied!';

    document.body.appendChild(toast);

    // =========================
    // POSITION NEAR CURSOR
    // =========================

    const offsetX = 12;
    const offsetY = 12;

    let left = event.clientX + offsetX;
    let top = event.clientY + offsetY;

    // Không cho toast chạy ra ngoài bên phải
    const toastWidth = toast.offsetWidth;
    const toastHeight = toast.offsetHeight;

    if (left + toastWidth > window.innerWidth) {
      left = event.clientX - toastWidth - offsetX;
    }

    // Không cho toast chạy ra ngoài phía dưới
    if (top + toastHeight > window.innerHeight) {
      top = event.clientY - toastHeight - offsetY;
    }

    toast.style.left = `${left}px`;
    toast.style.top = `${top}px`;

    // Hiện toast
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    // =========================
    // HIDE AFTER 2 SECONDS
    // =========================
    setTimeout(function () {
      toast.classList.remove('is-visible');

      setTimeout(function () {
        toast.remove();
      }, 200);

    }, 1000);


  });
$('.zippay svg').click(function(){
    $(".zip-logo").trigger("click");
  });
  $( ".shop-the-look__products .horizontal-product" ).each(function( index ) {
    var counter = index + 1;
    $( this ).append( '<button class="shop-the-look__dot"><span>'+counter+"</span></button>" );
  });
  
  var swiper = 
     new Swiper('.swiper-container',{
       slidesPerView: '1',
       loop: 1,
       spaceBetween: 0,
       autoplay: false,
       grabCursor: true,
       centeredSlides: true,
       slidesPerView: 'auto',
       nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
       // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
     }
    );
    $('.search-button').click(function() {
      $('.header-search .search-input input').trigger("click");
      document.getElementById("boost-sd__search-widget-init-input-1")?.focus();
    });
    if($('#boost-sd__search-widget-init-input-0').length){
      document.querySelector("#boost-sd__search-widget-init-input-0")
      .addEventListener("click", () => {
        setTimeout(() => {
          document.getElementById("boost-sd__search-widget-init-input-1")?.focus();
        }, 150);
      });
    }


$('.edit-location').click(function() {
  $('#ShippingLocation').val('');
  $('.shipping-estimator').removeClass('show-results');
  });
$('#read-shipping-terms').click(function() {
    if($(".shipping_accordion").attr("aria-expanded") == "false"){
      $(".shipping_accordion .accordion__toggle").trigger("click");
    }
    
    $('html, body').animate({
        scrollTop: $(".shipping_accordion").offset().top - 200
    }, 800);
  });

  $('.more-less').click(function() {
    $('.more-text').toggleClass('open');
    if ($('.more-less:contains("Read More...")').length > 0) {
        $('.more-less').text('Show Less');
    } else if ($('.more-less:contains("Show Less")').length > 0){
        $('.more-less').text('Read More...');
    }
  });
  
  $('.search-icon').click(function() {
    $('.header-search .search-input input').trigger("click");
  });
  $('.icon-shiping').click(function() {
    if($(".shipping_accordion").attr("aria-expanded") == "false"){
      $(".shipping_accordion .accordion__toggle").trigger("click");
    }
    
    $('html, body').animate({
        scrollTop: $(".shipping_accordion").offset().top - 200
    }, 800);
  });
  $('.icon-warranty').click(function() {
    if($(".warranty_accordion").attr("aria-expanded") == "false"){
      $(".warranty_accordion .accordion__toggle").trigger("click");
    }
    $('html, body').animate({
        scrollTop: $(".warranty_accordion").offset().top - 200
    }, 800);
  });
  $('.icon-return').click(function() {
    if($(".return_accordion").attr("aria-expanded") == "false"){
      $(".return_accordion .accordion__toggle").trigger("click");
    }
    $('html, body').animate({
        scrollTop: $(".return_accordion").offset().top - 200
    }, 800);
  });

  $('.tabs-nav__button').click(function() {
    var goto = $(this).attr("aria-controls");
    $('html, body').animate({
        scrollTop: $("#"+goto).offset().top - 100
    }, 800);
    $(this).css("scroll-snap-align","start");
        setTimeout(function(){
          $(this).css("scroll-snap-align","unset");
        }, 1000);

  });

  if($(".product-tabs .tabs-nav__button.active").length < 1){
      $(".product-tabs .tabs-inner button:first-child").addClass('active');
        $(".product-tabs .tabs-inner button:first-child").attr("aria-selected","true");
        $(".product-tabs .tabs-inner button:first-child").css("scroll-snap-align","start");
        setTimeout(function(){
          $(".product-tabs .tabs-inner button:first-child").css("scroll-snap-align","unset");
        }, 1000);
        $(".tabs-inner").css("--selected-index",0);
        $(".tabs-inner").attr("selected-index",0);
  }

  $(window).on('scroll',function(){
    let $scrollTop = $(this).scrollTop();
    let $headerHeight = $('.shopify-section--header').outerHeight() + $('.tabs-nav__button').outerHeight() + 50;
    if($('.product-tabs').length){
      var product_tabs_offset = $('.product-tabs').offset().top; 
    var window_scroll_top = $(window).scrollTop();
    var window_height = $(window).height();
    var headerTop = product_tabs_offset - window_scroll_top;
    var newTop = $('.shopify-section--header').height() - headerTop;
    if (headerTop < 125) {
      $('.shopify-section--header').css("top","-"+newTop+"px");
    }else{
      $('.shopify-section--header').css("top","0px");
    }
    }
    
  
    
    $('.tab-content[slot="content"]').each(function(index, element){
      let $self = $(this);
      let $selfHeight = $self.outerHeight();
      let $offsetTop = $self.offset().top;
      let $target = $('button[id="'+$self.attr('aria-labelledby')+'"]');
      if ($scrollTop + $headerHeight >= $offsetTop && $scrollTop + $headerHeight <= $offsetTop + $selfHeight ) {
        $target.addClass('active');
        $target.attr("aria-selected","true");
        $target.css("scroll-snap-align","start");
        setTimeout(function(){
          $target.css("scroll-snap-align","unset");
        }, 1000);
        $(".tabs-inner").css("--selected-index",index);
        $(".tabs-inner").attr("selected-index",index);
      } else {
        $target.removeClass('active');
        $target.attr("aria-selected","false");
      }
    });
    if($(".product-tabs .tabs-nav__button.active").length < 1){
      $(".product-tabs .tabs-inner button:first-child").addClass('active');
        $(".product-tabs .tabs-inner button:first-child").attr("aria-selected","true");
        $(".product-tabs .tabs-inner button:first-child").css("scroll-snap-align","start");
        setTimeout(function(){
          $(".product-tabs .tabs-inner button:first-child").css("scroll-snap-align","unset");
        }, 1000);
        $(".tabs-inner").css("--selected-index",0);
        $(".tabs-inner").attr("selected-index",0);
  }
  });	
  
  
  if($(window).width() <767){
    $('.product-gallery__thumbnail.video.fake').click(function(){
      $('.product-gallery__thumbnail.pagedot').trigger('click');
    });
    $('.footer__block--menu p, .footer__block--text p ').click(function(){
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $(this).parent().addClass('active');
      }
    });
    //$( ".reviews-tab" ).append( $(). );
  }

    
    

  setTimeout(function(){
      isUrlExists($(".product-info__vendor .brand img").attr('src'), function(status){
          if(status === 404){
             $('.product-info__vendor').addClass('not-found-img');
            $('.product-info .shopify-block.shopify-app-block').addClass('no-brand');
          }
      });
    }, 1000);

    //var priceAfterpay = $(".afterpay-main-text strong").html();
    // if($(window).width() <767){
    //   $(".afterpay-main-text").html("4 payments of <strong>"+ priceAfterpay +"</strong>");
    //   alert(priceAfterpay);
    // }else{
    //   $(".afterpay-main-text").html("4 interest-free payments of <strong>"+ priceAfterpay +"</strong>");
    // }
    $(".product-info__payment-terms").insertAfter(".product-info__buy-buttons");
    $(".product-info__payment-terms").show();
    $(".shopify-app-block").each(function(index, element) {
      var idApp = $(this).attr("id");
      if (idApp.includes("wishlist_power_block_wishlist_product_page_button")) {
        $(".wishlist-button").html("");
        $("#"+idApp).appendTo(".wishlist-button");
      }
    });

    if($(".shipping-estimator").length){
      $("square-placement").appendTo(".cart-form");
    }
    
  
});

function isUrlExists(url, cb){
    jQuery.ajax({
        url:      url,
        dataType: 'text',
        type:     'GET',
        complete:  function(xhr){
            if(typeof cb === 'function')
               cb.apply(this, [xhr.status]);
        }
    });
}

document.addEventListener("cart:drawer:updated", () => {
  setTimeout(() => {
    loadCartRecommendations("#cart-recommendations2");
  }, 2000);
});

document.addEventListener("DOMContentLoaded", () => {
    loadCartRecommendations("#cart-recommendations2");
});


function loadCartRecommendations(selector) {
  const container = document.querySelector(selector);

  if (!container) return;

  const productId = container.dataset.productId;

  if (!productId) {
    container.remove();
    return;
  }

  const url =
    `${container.dataset.url}?section_id=cart-recommendations` +
    `&product_id=${productId}` +
    `&limit=${container.dataset.limit}`;

  fetch(url)
    .then(res => res.text())
    .then(html => {

      if (!html) {
        container.remove();
        return;
      }

      const doc = new DOMParser().parseFromString(html, "text/html");

      const section = doc.querySelector(
        "#shopify-section-cart-recommendations"
      );

      if (!section || !section.innerHTML.trim()) {
        container.remove();
        return;
      }

      container.innerHTML = section.innerHTML;

      enableCartRecommendationsDrag(container);
      enableCartRecommendationsThumbScrollbar(container);

      document.dispatchEvent(
        new CustomEvent("theme:section:load")
      );
    })
    .catch(() => {
      container.remove();
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#cart-recommendations');
  if (!container) return;

  const productId = container.dataset.productId;

  // ❗ nếu cart rỗng → remove luôn
  if (!productId) {
    container.remove();
    return;
  }

  const url = `${container.dataset.url}?section_id=cart-recommendations&product_id=${productId}&limit=${container.dataset.limit}`;

  fetch(url)
    .then(res => res.text())
    .then(html => {
      if (!html) {
        container.remove();
        return;
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('#shopify-section-cart-recommendations');

      // ❗ check kỹ null + empty
      if (!section || section.innerHTML.trim() === '') {
        container.remove();
        return;
      }

      container.innerHTML = section.innerHTML;

      enableCartRecommendationsDrag(container);
      enableCartRecommendationsThumbScrollbar(container);

      // re-init JS của Impact
      document.dispatchEvent(new CustomEvent('theme:section:load'));
    })
    .catch(() => {
      container.remove();
    });
});

function enableCartRecommendationsDrag(root) {
  const carousels = root.querySelectorAll('scroll-carousel');
  carousels.forEach((carousel) => {
    if (carousel.dataset.dragEnabled === 'true') return;
    carousel.dataset.dragEnabled = 'true';
    carousel.classList.add('is-draggable');

    let isDown = false;
    let hasDragged = false;
    let startX = 0;
    let startScroll = 0;
    let pointerId = null;
    const DRAG_THRESHOLD = 5;

    const onPointerDown = (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('a, button, input, textarea, select, [role="button"]')) return;

      isDown = true;
      hasDragged = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = carousel.scrollLeft;
      carousel.classList.add('is-dragging');
    };

    const onPointerMove = (e) => {
      if (!isDown || e.pointerId !== pointerId) return;
      const dx = e.clientX - startX;

      if (!hasDragged && Math.abs(dx) > DRAG_THRESHOLD) {
        hasDragged = true;
        try { carousel.setPointerCapture(pointerId); } catch (_) {}
      }

      if (hasDragged) {
        e.preventDefault();
        carousel.scrollLeft = startScroll - dx;
      }
    };

    const endDrag = (e) => {
      if (!isDown) return;
      if (e && e.pointerId !== pointerId) return;
      isDown = false;
      carousel.classList.remove('is-dragging');
      try { carousel.releasePointerCapture(pointerId); } catch (_) {}

      if (hasDragged) {
        const suppressClick = (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
        };
        carousel.addEventListener('click', suppressClick, { capture: true, once: true });
        setTimeout(() => carousel.removeEventListener('click', suppressClick, { capture: true }), 0);
      }
      pointerId = null;
    };

    carousel.addEventListener('pointerdown', onPointerDown);
    carousel.addEventListener('pointermove', onPointerMove);
    carousel.addEventListener('pointerup', endDrag);
    carousel.addEventListener('pointercancel', endDrag);
    carousel.addEventListener('pointerleave', endDrag);
    carousel.addEventListener('dragstart', (e) => e.preventDefault());
  });
}

// Swap the default growing scrollbar for a sliding thumb inside #cart-recommendations.
// The theme's <scroll-progress> exposes `(scrollLeft + clientWidth) / scrollWidth` via --scroll-progress,
// which — combined with scaleX from the left — looks like a bar that widens as you scroll.
// Here we instead write the thumb ratio (clientWidth / scrollWidth) and offset (scrollLeft / scrollWidth)
// onto the element so CSS can render a fixed-width thumb that translates across the track.
function enableCartRecommendationsThumbScrollbar(root) {
  const progresses = root.querySelectorAll('scroll-progress');
  progresses.forEach((progress) => {
    if (progress.dataset.thumbEnabled === 'true') return;
    const observesId = progress.getAttribute('observes');
    const scrolled = observesId ? document.getElementById(observesId) : null;
    if (!scrolled) return;
    progress.dataset.thumbEnabled = 'true';

    const update = () => {
      const { scrollLeft, clientWidth, scrollWidth } = scrolled;
      if (!scrollWidth) return;
      const ratio = Math.min(1, clientWidth / scrollWidth);
      const offset = Math.max(0, Math.min(1 - ratio, scrollLeft / scrollWidth));
      progress.style.setProperty('--thumb-ratio', ratio.toFixed(6));
      progress.style.setProperty('--thumb-offset', offset.toFixed(6));
    };

    scrolled.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(scrolled);
    }
    update();
  });
}

